export const leftPadding = 256;
export const topPadding = 64;
export const daysOfTheWeek = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
];
//# sourceMappingURL=Consts.js.map